import { useTranslation } from 'react-i18next';
import { CardActionGroup } from '@/common/components/CardActionGroup/CardActionGroup';
import { CardActionLink } from '@/common/components/CardActionLink/CardActionLink';
import { Icon } from '@/common/components/Icons/Icon';
import { MARKET } from '@/common/constants/markets';
import { useMarket } from '@/common/hooks/useMarket';

export function ProfileSocialSection() {
  const { slug } = useMarket();
  const { t } = useTranslation();

  const LINKEDIN_URL = 'http://linkedin.com/company/getcoverflex';
  const INSTAGRAM_URL =
    slug === MARKET.IT
      ? 'https://www.instagram.com/coverflex.it'
      : 'https://www.instagram.com/getcoverflex';
  const FACEBOOK_URL = 'https://www.facebook.com/getcoverflex';

  return (
    <CardActionGroup
      title={t('dashboard.profile.sections.social.title')}
      size="sm"
    >
      <CardActionLink
        title="LinkedIn"
        icon={<Icon icon={['fab', 'linkedin']} />}
        href={LINKEDIN_URL}
        external
      />
      <CardActionLink
        title="Instagram"
        icon={<Icon icon={['fab', 'instagram']} />}
        href={INSTAGRAM_URL}
        external
      />
      <CardActionLink
        title="Facebook"
        icon={<Icon icon={['fab', 'facebook']} />}
        href={FACEBOOK_URL}
        external
      />
    </CardActionGroup>
  );
}
